<template>
  <div class="w-100">

    <m-product-offer1 :offer-status="offerStatus" :offer-type="offerType" class="position-absolute" :product="product"/>

    <m-card922 :alt="product.name" :image="product.thumbnail" :link-target="productCardLink"
               :image-link="{ name: 'Product', params: { name: product.raw_link } }">


      <template #p-1>

        <m-product-price100 class="product-price-100" :product="product"/>

      </template>


      <template #p-2>
        <m-product-card-keywords1 :product="product" :showKeywords="showKeywords"/>

      </template>

      <template #p-3>
        <m-a :href="{ name: 'Product', params: { name: product.raw_link } }">
          <h6 class="product-card-903-text">{{ contentSlicer(product.name, 50) }}</h6>
        </m-a>
      </template>

    </m-card922>
  </div>

</template>

<script>
import mCard922 from "../../Cards/Card922";
import mProductCardQuantityManager1 from "../../Product/QuantityManager/Card/ProductCardQuantityManager1";
import mProductPrice100 from "../../Product/ProductPrice100";
import mA from '../../Tags/A'
import mProductOffer1 from "../../Product/ProductOffer/ProductOffer1";
import {OfferProps} from '../ProductOffer/ProductOfferProps'
import {shoppingCartFunctions} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import mProductCardKeywords1 from "../../Product/ProductCardKeywords/ProductCardKeywords1.vue";
import {productCardKeywords} from "../../Product/ProductCardKeywords/ProductCardKeywords";


export default {
  name: "ProductCard922",
  components: {mCard922, mProductCardQuantityManager1, mA, mProductPrice100, mProductOffer1, mProductCardKeywords1},
  props: {
    product: {},
    productCardLink: {
      default: '_self',
    },
    inActiveQuantityManager: {
      type: Boolean,
      default: true
    },
    showKeywords: {
      type: Boolean,
      default: false
    },
    ...OfferProps,
    ...productCardKeywords
  },
  methods: {
    ...shoppingCartFunctions,
  }
}
</script>

<style scoped>
.product-card-903-keyword {
  background: gray;
}

.product-price-100 :deep(.product-price) {
  color: white !important;
}

</style>